import React, {useEffect, useState} from 'react';
import {Button} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {bbFindCustomerTagsById} from "../../../../util/bbHelpers";
import {CircularProgress} from "@mui/material";
import {
    disableCustomerEarlyAccess,
    enableCustomerEarlyAccess,
    enableUserEarlyAccess,
    fetchCustomers
} from "../../../../actions";

const CustomerEarlyAccessControl = ({customerId=null,}) => {

    const { customers, loadingCustomers } = useSelector(({customer})=>customer);
    const customer = customers && customerId ? customers[customerId] : null;

    const earlyAccessTags = bbFindCustomerTagsById(customer, 54);
    const hasEarlyAccessTags = earlyAccessTags && Array.isArray(earlyAccessTags) && earlyAccessTags.length> 0;

    const dispatch = useDispatch();

    const [localState, setLocalState] = useState(hasEarlyAccessTags);
    const [localLoading, setLocalLoading] = useState(false);

    // console.log(customer.CustomerName, customer.Tags, earlyAccessTags, earlyAccessTags[0])

    const handleClick = () => {
        setLocalLoading(true);

         if (hasEarlyAccessTags){
            setLocalState(false);
            dispatch(disableCustomerEarlyAccess(earlyAccessTags[0], customerId));
        } else if(!hasEarlyAccessTags){
             dispatch(enableCustomerEarlyAccess(customerId));
             setLocalState(true);

         }

    }

    useEffect(()=>{
        if(!customers && !loadingCustomers){
            fetchCustomers();
        }

        if(customers && customer){
            setLocalState(hasEarlyAccessTags);
        }

        setLocalLoading(false);

    }, [dispatch, customers, loadingCustomers, customer, hasEarlyAccessTags])


    return(
        <>
            { localLoading && <CircularProgress size={30} /> }
            <Button
                variant={"contained"}
                color={localState ? "primary" : "default"}
                onClick={handleClick}>
                {localState ? "Disable" : "Enable"}
            </Button>
        </>
    )
}

export default CustomerEarlyAccessControl;